import { createContext, useContext, useMemo } from 'react'
import { platformWeb, useFetchPublic } from '../services'

export const AppConfigContext = createContext(null)

export const AppConfigContextProvider = ({ children }) => {
  // All 3 API calls happen in PARALLEL (at the same time)
  const setupFetch = useFetchPublic('/api/external/meta', '', 'web')
  const localeFetch = useFetchPublic(
    '/api/external/locale',
    `&platformType=${platformWeb}&product=com.aumhum.web`,
    'web'
  )
  const themeFetch = useFetchPublic('/api/external/theme', '', 'web')

  const value = useMemo(
    () => ({
      setup: {
        loading: setupFetch.loading,
        data: setupFetch.data,
        error: setupFetch.error,
      },
      locale: {
        loading: localeFetch.loading,
        data: localeFetch.data,
        error: localeFetch.error,
        refreshFunction: localeFetch.refreshFunction,
      },
      theme: {
        loading: themeFetch.loading,
        data: themeFetch.data,
        error: themeFetch.error,
      },
    }),
    [
      setupFetch.loading,
      setupFetch.data,
      setupFetch.error,
      localeFetch.loading,
      localeFetch.data,
      localeFetch.error,
      localeFetch.refreshFunction,
      themeFetch.loading,
      themeFetch.data,
      themeFetch.error,
    ]
  )

  return <AppConfigContext.Provider value={value}>{children}</AppConfigContext.Provider>
}

// Helper hook for direct access (optional, for future migration)
export const useAppConfig = () => {
  const context = useContext(AppConfigContext)
  if (!context) {
    throw new Error('useAppConfig must be used within AppConfigContextProvider')
  }
  return context
}

